export const PRIMARY_ORANGE = "#ff5722";
export const THEME_ORANGE_BG = "rgba(255, 87, 34, 0.12)";
export const PAGE_BG = "#ffffff";
export const TABLE_HEADER_BG = "#f5f5f5";
export const FILTER_DRAWER_WIDTH = 400;

export const OVERVIEW_DARK_GRADIENT =
  "linear-gradient(180deg, #101828 0%, #1a2332 100%)";
export const OVERVIEW_DARK_BORDER = "rgba(255, 255, 255, 0.08)";
export const OVERVIEW_MUTED_TEXT = "rgba(255, 255, 255, 0.55)";
export const OVERVIEW_TREND_UP = "#4ade80";
export const OVERVIEW_TREND_DOWN = "#f87171";

export const OVERVIEW_LIGHT_CARD_BG = "#fafafa";
export const OVERVIEW_SECTION_BORDER = "#eee";
